export const { useExclusiveView } = window.Megogo.interactive.hooks;
